import { createFileRoute } from '@tanstack/react-router'
import { EdyOrganizationPage } from '@/pages/platform-users/ui/EdyOrganizationPage'

export const Route = createFileRoute('/organizations_/$orgId')({
  component: EdyOrganizationPage,
})
